import { asyncAction } from 'lib/action';

export const getCurrenciesAction = asyncAction('DICTIONARY/GET_CURRENCIES');
export const getTimezonesAction = asyncAction('DICTIONARY/GET_TIMEZONES');
